<template>
  <div class="cell">
    <van-panel class="group">
      <template #header>
        <van-cell-group>
          <van-cell
            title="个人设置"
            icon="setting-o"
            value=""
            is-link
            @click="personsetting()"
            title-style="font-size:14px;color: rgb(51, 51, 51);
    font-weight: bold;"
          />
          <van-cell
            title="当前项目"
            icon="setting-o"
            :value="projectname"
            is-link
            @click="ShowPopub()"
            title-style="font-size:14px;color: rgb(51, 51, 51);
    font-weight: bold;"
          />
        </van-cell-group>
        <!-- <van-cell-group>
          <van-cell
            title="项目设置"
            icon="setting-o"
            value=""
            is-link
            @click="projectsetting()"
            title-style="font-size:14px;color: rgb(51, 51, 51);
    font-weight: bold;"
          />
        </van-cell-group> -->
      </template>
    </van-panel>

    <div class="actionWrapper" v-if="logInfo">
      <van-button block @click="logout" shape="circle">{{
        $lang["退出登录"]
      }}</van-button>
    </div>
    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择项目"
        show-toolbar
        :columns="ProjectList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import clipboard from "../../../utils/clipboard";
export default {
  name: "cell",
  data() {
    return {
      logInfo: false,
      showStore: false,
      showPoints: false,
      showPopup: false,
      projectname: localStorage.getItem("projectname"),
      ProjectList: this.$store.state.projectList,
    };
  },
  created() {
    this.logInfo = localStorage.getItem("token");
    this.$store.dispatch("syncGetProjectList").then(() => {
      this.ProjectList = this.$store.state.projectList;
      
    });
    //
  },
  computed: {},
  methods: {
    personsetting() {
      //this.$store.state.
      this.$router.push("/my/personsetting");
    },
    projectsetting() {
      this.$router.push("/my/projectsetting");
    },
    ShowPopub(index) {
      this.ProjectList = this.$store.state.projectList;
      this.showPopup = true;
    },
    onPopupConfirm(value) {
      this.projectname = value;
      console.log(value);
      localStorage.setItem("projectname", this.projectname);
      this.showPopup = false;
    },
    // 退出登录
    logout() {
      localStorage.removeItem("token");

      this.nicname = "";
      this.passWord = "";
      this.$toast({
        message: `${this.$lang["已退出"]}`,
      });
      this.$store.commit("clear");
      this.$router.replace("/login");
    },
    copy(item) {
      clipboard.handleClipboard(
        item,
        event,
        () => {
          Toast.success(this.$lang["复制成功"]);
        },
        () => {
          Toast.fail(this.$lang["复制失败"]);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.group {
  margin: 10px;
  background: #fd9126;
  color: #fff;
  .van-cell__title {
    sapn {
      font-size: 14px;
      color: rgb(51, 51, 51);
      font-weight: bold;
    }
  }
}
.cell {
  .actionWrapper {
    padding: 10px;

    .van-button {
      background: #fd9126;
      color: #fff;
    }
  }
}
</style>